module.exports = "/_next/static/images/search_bg_8-d9eea284cc02395c1ecf9daa748baed6.jpg";